import { ordinarySearchClick } from '../../features/search/searchSession';
import { useSearchSession } from '../../features/search/SearchSessionContext';
import { useUserStore } from '../../stores/userStore';
import { rememberSearchSelection } from '../../features/search/continuationArtist';
import { Grid, useMediaQuery } from '@mui/material';
import { appCopy } from '../../app-ui/baseline';
import AppContentSection from '../../app-ui/AppContentSection';
import { useWebLocale } from '../../contexts/WebLocaleContext';
import { displayResultCount, resultCategoryLabel } from '../../features/search/resultPresentation';
import { useSearchParams } from 'react-router-dom';
import SearchResultRow from '../../components/content/SearchResultRow';
import AlbumVerticalCard from '../../components/card/AlbumVerticalCard';
import theme from '../../theme';
import { REFERRER_TYPE } from '../../constants/gaEnums';

const SearchResultSection = ({ title, count, items }) => {
  const session = useSearchSession();
  const userId = useUserStore((s) => s.user?.id);
  const { locale } = useWebLocale();
  const [searchParams] = useSearchParams();
  const query = searchParams.get('q');
  const isXs = useMediaQuery(theme.breakpoints.down('md'));
  const isLg = useMediaQuery(theme.breakpoints.up('lg'));

  const getCardComponent = (title, item, index) => {
    switch (title) {
      case 'Artists':
        return <SearchResultRow item={item} kind="artist" resultPosition={index + 1} summary />;
      case 'Reviews':
        return (
          <AlbumVerticalCard
            appRatios
            key={item.sourceId}
            albumId={item.albumId}
            sourceId={item.sourceId}
            albumSource={item.albumSource}
            slug={item.slug}
            imageUrl={item.albumImageUrl}
            albumName={item.title}
            contentRating={item.contentRating}
            artistName={item.artist?.name}
            artistId={item.artist?.sourceId}
            artistDbId={item.artist?.id}
            artistSource={item.artist?.artistSource}
            artistSlug={item.artist?.slug}
            albumAvgRating={item.averageRating}
            commentCount={item.commentCount}
            bookmarkCount={item.bookmarkCount}
            releaseDate={item.releaseDate}
            isStarred={item.isStarred}
            hideBookmarkCount
            hideReviewMetaOnMobile
            ratingSolo={!isLg}
            dateSolo={isXs}
            smallText
            referrerType={REFERRER_TYPE.SEARCH}
          />
        );
      case 'Lists':
      case 'Mixes':
        return <SearchResultRow item={item} kind="playlist" resultPosition={index + 1} summary />;
      default:
        return null;
    }
  };

  const isGridLayout = title === 'Reviews';

  const categoryPath = title === 'Mixes' ? 'lists' : title.toLowerCase();
  const morePath = `/search/${categoryPath}?q=${encodeURIComponent(query || '')}`;
  return (
    <AppContentSection
      title={
        categoryPath === 'lists'
          ? appCopy(locale, 'common.playlist')
          : resultCategoryLabel(categoryPath, locale)
      }
      subtitle={displayResultCount(count)}
      to={morePath}
      inlineMore
    >
      {/* 카드 목록 */}
      {isGridLayout ? (
        <Grid container columnSpacing={{ xs: 2, md: 2, lg: 2.5 }} rowSpacing={3}>
          {items.slice(0, 4).map((item, index) => (
            <Grid
              onClickCapture={(event) => {
                if (
                  !ordinarySearchClick(event) ||
                  !event.target.closest('a') ||
                  event.target.closest('button')
                )
                  return;
                const link = event.target.closest('a');
                if (!new URL(link.href).pathname.startsWith('/reviews/')) return;
                rememberSearchSelection('album', item, query, userId);
                session?.open({ query, kind: 'album', item, position: index + 1 });
              }}
              item
              xs={title === 'Reviews' ? 6 : 4}
              md={3}
              key={item.id || item.sourceId}
            >
              {getCardComponent(title, item, index)}
            </Grid>
          ))}
        </Grid>
      ) : (
        <div className="pp-search-row-list">
          {items.slice(0, 3).map((item, index) => (
            <div key={item.id || item.sourceId}>{getCardComponent(title, item, index)}</div>
          ))}
        </div>
      )}
    </AppContentSection>
  );
};

export default SearchResultSection;
